import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IndicacionService {
  private indicacionApiUrl = `${environment.apiUrl}/indicaciones`;
  constructor(private http: HttpClient) {}
  // ============================================
  //            NUEVAS INDICACIONES
  //  ===========================================

  crearIndicacion(indicacion: any): Observable<any> {
    return this.http.post<any>(this.indicacionApiUrl, indicacion);
  }

  obtenerIndicaciones(): Observable<any[]> {
    return this.http.get<any[]>(this.indicacionApiUrl);
  }

  actualizarIndicacion(idIndicacion: string, indicacion: any): Observable<any> {
    return this.http.patch<any>(`${this.indicacionApiUrl}/${idIndicacion}`, indicacion);
  }

  eliminarIndicacion(id: string): Observable<any> {
    return this.http.delete<any>(`${this.indicacionApiUrl}/${id}`);
  }
}
